import { createTheme } from "@mui/material/styles";

export const theme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#004b93",
      light: "#336bb8",
      dark: "#003366",
    },
    secondary: {
      main: "#dc004e",
      light: "#ff5983",
      dark: "#9a0036",
    },
    background: {
      default: "#faf7f7",
    },
  },
  typography: {
    fontFamily: '"Monserrat"',
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        "*": {
          margin: 0,
          padding: 0,
        },
        body: {
          fontFamily: "Monserrat",
        },
      },
    },
  },
});
